<template>
  <SideMenuBase :menuGroups="menuGroups" />
</template>

<script setup>
import SideMenuBase from '@/components/layout/SideMenuBase.vue'

const menuGroups = [
  {
    title: 'Search',
    items: [
      { label: 'Item', path: '/inventory/search-item' },
      { label: 'Job Details', path: '/inventory/job-details' },
      { label: 'Scheduled Jobs', path: '/inventory/scheduled-jobs', requiredPermission: 'inventory.scheduled_jobs.access' },
      { label: 'Inventory Analysis', path: '/inventory/analysis', requiredPermission: 'inventory.analysis.access' }
    ]
  },
  {
    title: 'Create',
    items: [
      { label: 'Count', path: '/inventory/count', requiredPermission: 'inventory.count.access' },
      { label: 'Order', path: '/inventory/order', requiredPermission: 'inventory.order.access' },
      { label: 'Transfer', path: '/inventory/transfer', requiredPermission: 'inventory.transfer.access' },
      { label: 'Label', path: '/inventory/label', requiredPermission: 'inventory.label.access' }
    ]
  },
  {
    title: 'Initiate',
    items: [
      { label: 'Replenishment', path: '/inventory/replenishment', requiredPermission: 'inventory.replenishment.access' },
    ]
  },
  {
    title: 'Admin',
    items: [
      { label: 'Invoice Closeout', path: '/inventory/invoice-closeout', requiredPermission: 'inventory.invoice_closeout.access' },
      { label: 'Cost Audit', path: '/inventory/cost-audit', requiredPermission: 'inventory.cost_audit.access' }
    ]
  }
]
</script>
